module.exports = __webpack_public_path__ + "img/glass_unknown.4b9d24f.svg";